export const champsAudioEffects: Map<string, string> = new Map<string, string>([
  ['adventure_champs_ambiance', 'fx/adventure_champs_ambiance.mp3'],
  ['adventure_champs_biathlon', 'fx/adventure_champs_biathlon.mp3'],
  ['adventure_champs_crowd_halfpipe', 'fx/adventure_champs_crowd_halfpipe.mp3'],
  ['adventure_champs_snowboarding', 'fx/adventure_champs_snowboarding.mp3'],
  ['adventure_champs_ski_lift', 'fx/adventure_champs_ski_lift.mp3'],
  ['adventure_champs_crowd_hockey', 'fx/adventure_champs_crowd_hockey.mp3'],
  ['adventure_champs_hockey', 'fx/adventure_champs_hockey.mp3'],
  ['adventure_champs_crowd_sled', 'fx/adventure_champs_crowd_sled.mp3'],
  ['adventure_champs_skating', 'fx/adventure_champs_skating.mp3'],

  ['world_champs_plane_right_to_left', 'fx/world_champs_plane_right_to_left.mp3'],
  ['world_champs_plane_left_to_right', 'fx/world_champs_plane_left_to_right.mp3'],
  ['world_champs_jetski', 'fx/world_champs_jetski.mp3'],
  ['world_champs_volcano_eruption', 'fx/world_champs_volcano_eruption.mp3'],
  ['world_champs_curling', 'fx/world_champs_curling.mp3'],
  ['world_champs_tennis', 'fx/world_champs_tennis.mp3'],
  ['world_champs_pingpong', 'fx/world_champs_pingpong.mp3'],
  ['world_champs_sea', 'fx/world_champs_sea.mp3'],
  ['world_champs_periscope', 'fx/world_champs_periscope.mp3'],
  ['world_champs_volleyball', 'fx/world_champs_volleyball.mp3'],
  ['world_champs_turner', 'fx/world_champs_turner.mp3'],
  ['world_champs_wrestling', 'fx/world_champs_wrestling.mp3'],
]);